require('./brokerETFsSellStep2.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');

// @commons
const { OKMessage } = require('commonsComponents/OKMessage');
const StocksBuySellSummary = require('components/broker/commons/stocksBuySellSummary/stocksBuySellSummary');
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @components
const BrokerETFsSellStep2ExAnteDetails = require('components/broker/brokerETFsSell/brokerETFsSellStep2ExAnteDetails/brokerETFsSellStep2ExAnteDetails');

// @constant
const {
    BROKER_STOCKS_BUY_SELL_SUMMARY_SELL_MODIFIER,
    FIRST_STEP,
    CHARGE_ACCOUNT_PREFIX,
    TYPE_ETFS
} = require('constants/index');
const { BROKER_STOCKS_BUY_ID } = require('constants/operationTypes');
const { ETFS_SELL_SHOW_COST } = require('constants/flagBasedFeatures');

class BrokerETFsSellStep2 extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        const { getExAnteData, immFlagBasedFeatures, history } = this.props;
        if (immFlagBasedFeatures.get(ETFS_SELL_SHOW_COST)) {
            getExAnteData(history);
        }
    }

    buildDetailSection() {
        const {
            productFile,
            immBrokerETFsSell,
            immStocksContracts,
            immFlagBasedFeatures,
        } = this.props;
        const step1 = immBrokerETFsSell.get("steps").get(FIRST_STEP);
        const selectedContractValue = immBrokerETFsSell.getIn([
            "steps",
            FIRST_STEP,
            "stocksContractSelectedValue",
        ]);
        const stockContract = immStocksContracts.find((contract) => {
            return contract.get("contactNumber") === selectedContractValue;
        });
        return immFlagBasedFeatures.get(ETFS_SELL_SHOW_COST) ? (
            <BrokerETFsSellStep2ExAnteDetails
                productCurrency={"EUR"}
                stockContract={stockContract}
                stockDescription={productFile.get("companyName")}
                step1={step1}
                productFile={productFile}
                immBrokerETFsSell={immBrokerETFsSell}
            />
        ) : (
            <StocksBuySellSummary
                productName={formatText("broker-etfSummaryProductName")}
                stockContract={stockContract}
                stockDescription={productFile.get("companyName")}
                productCurrency={productFile.get("currency")}
                step1={step1}
                modifier={BROKER_STOCKS_BUY_SELL_SUMMARY_SELL_MODIFIER}
                productIso={productFile.get("micCode")}
                productType={TYPE_ETFS}
                titlesQuantityTitle="stocksBuySellSummaryTitlesQuantityParticipations"
            />
        );
    }

    buildDisclaimerSection() {
        const { immFlagBasedFeatures } = this.props;

        return immFlagBasedFeatures.get(ETFS_SELL_SHOW_COST) ? (
            <div className="etfs-sell-step2__disclaimer-ex-ante">
                <OKMessage
                    id="etfs-sell-step2-disclaimer"
                    type="informative"
                    visible={true}
                >
                    <div className="etfs-sell-step2__disclaimer-paragraph">
                        <FormattedText value="brokerETFsSell-disclaimerParagraph1" />
                    </div>
                    <div className="etfs-sell-step2__disclaimer-paragraph">
                        <FormattedText value="brokerETFsSell-disclaimerParagraph2" />
                    </div>
                </OKMessage>
            </div>
        ) : (
            <div className="etfs-sell-step2__disclaimer">
                <OKMessage
                    id="etfs-sell-step2-disclaimer"
                    type="informative"
                    visible={true}
                >
                    <FormattedText value="broker-etfsSellStep2DisclaimerText" />
                </OKMessage>
            </div>
        );
    }

    render() {
        const { immBrokerETFsSell, immStocksContracts, immFlagBasedFeatures } =
            this.props;
        const step1 = immBrokerETFsSell.get("steps").get(FIRST_STEP);
        const selectedContractValue = immBrokerETFsSell.getIn([
            "steps",
            FIRST_STEP,
            "stocksContractSelectedValue",
        ]);
        const stockContract = immStocksContracts.find((contract) => {
            return contract.get("contactNumber") === selectedContractValue;
        });

        if (!stockContract) {
            return;
        }

        const contractNumber = stockContract.get("walletNumber");
        const productNumber = stockContract.get("productNumber");
        const chargeAccount = `${CHARGE_ACCOUNT_PREFIX}${productNumber}${contractNumber}`;
        const titlesAmount = step1.get("titleQuantity");
        const operationParams = {
            bondsNumber: titlesAmount,
            chargeAccount: chargeAccount,
        };
        const detailsSection = this.buildDetailSection();
        const subtitle = immFlagBasedFeatures.get(
            ETFS_SELL_SHOW_COST
        ) ? null : (
            <p className="etfs-sell-step2__header-info">
                <FormattedText value="broker-etfsSellStep2HeaderText" />
            </p>
        );

        const footerText = immFlagBasedFeatures.get(
            ETFS_SELL_SHOW_COST
        ) ? null : (
            <p className="etfs-sell-step2__footer-text">
                <FormattedText value="broker-etfsSellStep2FooterText" />
            </p>
        );
        const disclaimerSection = this.buildDisclaimerSection();
        return (
            <div className="etfs-sell-step2">
                <header className="etfs-sell-step2__header">
                    <h2 className="etfs-sell-step2__header-title">
                        <FormattedText value="broker-etfsSellStep2HeaderTitle" />
                    </h2>
                    {subtitle}
                </header>
                <section className="etfs-sell-step2__section">
                    {detailsSection}
                </section>
                <footer className="etfs-sell-step2__section no-print-out">
                    {disclaimerSection}
                    {footerText}
                    <section className="etfs-sell-step2__signature-pattern-section">
                        <SignaturePattern
                            operationType={BROKER_STOCKS_BUY_ID}
                            operationParams={operationParams}
                        />
                    </section>
                </footer>
            </div>
        );
    }
}

BrokerETFsSellStep2.propTypes = {
    productFile: PropTypes.object.isRequired,
    immBrokerETFsSell: PropTypes.object.isRequired,
    immStocksContracts: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    getExAnteData: PropTypes.func,
    history: PropTypes.object.isRequired,
};

module.exports = withRouter(BrokerETFsSellStep2);
